var map = {
	"./img/NTFusion_logo.png": "rjt6",
	"./img/common/fb.png": "AgqH",
	"./img/common/logo.png": "8f4c",
	"./img/feature/role.png": "ZtaN",
	"./img/feature/title.png": "ozNp",
	"./img/feature6/sence2.png": "vu1d",
	"./img/feature6/title.png": "vPfm",
	"./img/header/home.png": "036c",
	"./img/home/pc/btn_gfcz.png": "eCOO",
	"./img/home/pc/common.png": "CPqL",
	"./img/home/pc/index1.png": "vbMr",
	"./img/home/pc/index1/describe.png": "Qgg5",
	"./img/home/pc/index1/logo.png": "7cCQ",
	"./img/home/pc/index1/slogan.png": "QuMJ",
	"./img/home/pc/news2.png": "RoBG",
	"./img/home/pc/role3/control/mo_btn1.png": "Bsza",
	"./img/home/pc/role3/control/mo_btn2.png": "YfS0",
	"./img/home/pc/role3/control/sg_btn1.png": "cSIb",
	"./img/home/pc/role3/control/sg_btn2.png": "JvYv",
	"./img/home/pc/role3/control/xl_btn1.png": "6W84",
	"./img/home/pc/role3/control/xl_btn2.png": "1zyz",
	"./img/home/pc/role3/control/yg_btn1.png": "DdqB",
	"./img/home/pc/role3/control/yg_btn2.png": "M4+X",
	"./img/home/pc/role3/control/ys_btn1.png": "tsH6",
	"./img/home/pc/role3/control/ys_btn2.png": "jY1s",
	"./img/home/pc/role3/control/zl_btn1.png": "+JYK",
	"./img/home/pc/role3/control/zl_btn2.png": "Ak1C",
	"./img/index/award1.png": "y+Kj",
	"./img/index/award1_a.png": "+vBq",
	"./img/index/award2.png": "zA+0",
	"./img/index/award2_a.png": "3BUx",
	"./img/index/award3.png": "BKoT",
	"./img/index/award3_a.png": "djBT",
	"./img/index/award4.png": "51Bg",
	"./img/index/award4_a.png": "kMXQ",
	"./img/index/award5.png": "LwUo",
	"./img/index/award5_a.png": "unSW",
	"./img/index/home.png": "E6dz",
	"./img/index/kv.jpg": "xBzX",
	"./img/management/1.png": "BxuI",
	"./img/management/2.png": "4Nzw",
	"./img/management/3.png": "N3we",
	"./img/management/4.png": "F4qM",
	"./img/management/5.png": "ZDQA",
	"./img/media5/role.png": "2VwX",
	"./img/media5/sence2.png": "xmfr",
	"./img/media5/title.png": "i2Sj",
	"./img/news2/move1.png": "NDs3",
	"./img/news2/move3.png": "pGh8",
	"./img/news2/title.png": "Rmxk",
	"./img/role3/bn/irole.png": "pxsg",
	"./img/role3/bn/name.png": "+LbL",
	"./img/role3/bn/role.png": "dNkY",
	"./img/role3/bz/irole.png": "WW/H",
	"./img/role3/bz/name.png": "oGPE",
	"./img/role3/bz/role.png": "pFa8",
	"./img/role3/ch/irole.png": "oOSM",
	"./img/role3/ch/name.png": "Gyfe",
	"./img/role3/ch/role.png": "8YFe",
	"./img/role3/cz/irole.png": "qH6F",
	"./img/role3/cz/name.png": "rma1",
	"./img/role3/cz/role.png": "PpTI",
	"./img/role3/jw/irole.png": "AYfV",
	"./img/role3/jw/name.png": "Gx6m",
	"./img/role3/jw/role.png": "n/a4",
	"./img/role3/kc/irole.png": "lnbE",
	"./img/role3/kc/name.png": "76CR",
	"./img/role3/kc/role.png": "8aPc",
	"./img/role3/kr/irole.png": "KMt7",
	"./img/role3/kr/name.png": "Ji60",
	"./img/role3/kr/role.png": "zQ7l",
	"./img/role3/lxx/irole.png": "5vE0",
	"./img/role3/lxx/name.png": "RrEh",
	"./img/role3/lxx/role.png": "KPKf",
	"./img/role3/mx/irole.png": "oeSW",
	"./img/role3/mx/name.png": "KB7M",
	"./img/role3/mx/role.png": "JhKC",
	"./img/role3/mz/irole.png": "/xds",
	"./img/role3/mz/name.png": "fqhn",
	"./img/role3/mz/role.png": "IVAL",
	"./img/role3/oo/irole.png": "IQL4",
	"./img/role3/oo/name.png": "Kmg+",
	"./img/role3/oo/role.png": "xOVM",
	"./img/role3/qa/irole.png": "Lz3f",
	"./img/role3/qa/name.png": "Hv4l",
	"./img/role3/qa/role.png": "kPhA",
	"./img/role3/swbnzk/irole.png": "sYmE",
	"./img/role3/swbnzk/name.png": "41jG",
	"./img/role3/swbnzk/role.png": "3ncW",
	"./img/role3/sy/irole.png": "rYSj",
	"./img/role3/sy/name.png": "reCb",
	"./img/role3/sy/role.png": "QeNX",
	"./img/role3/title.png": "wPA2",
	"./img/role3/tsz/irole.png": "U34K",
	"./img/role3/tsz/name.png": "UKLn",
	"./img/role3/tsz/role.png": "kd2n",
	"./img/role3/tysdags/irole.png": "TlZd",
	"./img/role3/tysdags/name.png": "Xmc+",
	"./img/role3/tysdags/role.png": "QS0P",
	"./img/role3/u/irole.png": "mcBV",
	"./img/role3/u/name.png": "PLQS",
	"./img/role3/u/role.png": "a/X6",
	"./img/role3/wxsjglm/irole.png": "nybv",
	"./img/role3/wxsjglm/name.png": "cnbB",
	"./img/role3/wxsjglm/role.png": "vikn",
	"./img/role3/xk/irole.png": "nrm0",
	"./img/role3/xk/name.png": "7daa",
	"./img/role3/xk/role.png": "6vgd",
	"./img/role3/yjyx/irole.png": "0VG7",
	"./img/role3/yjyx/name.png": "IPzT",
	"./img/role3/yjyx/role.png": "ez4y",
	"./img/role3/yzzzbq/irole.png": "fkLk",
	"./img/role3/yzzzbq/name.png": "Apvg",
	"./img/role3/yzzzbq/role.png": "1c8y",
	"./img/role3/zxrx/irole.png": "Ru2S",
	"./img/role3/zxrx/name.png": "Z+xs",
	"./img/role3/zxrx/role.png": "huTs",
	"./img/sprite2310.png": "MZrg",
	"./mobile_img/btn_gfcz.png": "AQ93",
	"./mobile_img/common.png": "6nni",
	"./mobile_img/common/dialog1.png": "OGBA",
	"./mobile_img/community/fb.png": "CgLw",
	"./mobile_img/feature/bg.jpg": "DmkO",
	"./mobile_img/feature/title.png": "8mP3",
	"./mobile_img/feature6/bg.jpg": "l5/t",
	"./mobile_img/feature6/title.png": "DWfP",
	"./mobile_img/home.png": "fA5/",
	"./mobile_img/index/award1.png": "kUob",
	"./mobile_img/index/award1_a.png": "cBc+",
	"./mobile_img/index/award2.png": "a3en",
	"./mobile_img/index/award2_a.png": "Kegx",
	"./mobile_img/index/award3.png": "RibV",
	"./mobile_img/index/award3_a.png": "nUS/",
	"./mobile_img/index/award4.png": "BA97",
	"./mobile_img/index/award4_a.png": "imk0",
	"./mobile_img/index/award5.png": "Cp7Z",
	"./mobile_img/index/award5_a.png": "1/zC",
	"./mobile_img/index/kv.jpg": "b6tz",
	"./mobile_img/index1.png": "Xs2G",
	"./mobile_img/index1/slogan.png": "Ke0n",
	"./mobile_img/media5/title.png": "XoDT",
	"./mobile_img/news2.png": "es/i",
	"./mobile_img/news2/title.png": "rtxl",
	"./mobile_img/role3/bn/irole.png": "ejRT",
	"./mobile_img/role3/bn/m_name.png": "Ib2a",
	"./mobile_img/role3/bn/m_role.png": "lyJp",
	"./mobile_img/role3/bz/irole.png": "V1sM",
	"./mobile_img/role3/bz/m_name.png": "9tM7",
	"./mobile_img/role3/bz/m_role.png": "YPUG",
	"./mobile_img/role3/ch/irole.png": "lEEd",
	"./mobile_img/role3/ch/m_name.png": "BYHS",
	"./mobile_img/role3/ch/m_role.png": "oG7A",
	"./mobile_img/role3/control2/mo1.png": "1NzC",
	"./mobile_img/role3/control2/mo2.png": "NkeB",
	"./mobile_img/role3/control2/sg1.png": "VHAz",
	"./mobile_img/role3/control2/sg2.png": "cMKR",
	"./mobile_img/role3/control2/xl1.png": "Ec8d",
	"./mobile_img/role3/control2/xl2.png": "i8XH",
	"./mobile_img/role3/control2/yg1.png": "8Ux/",
	"./mobile_img/role3/control2/yg2.png": "vTO9",
	"./mobile_img/role3/control2/ys1.png": "GJIB",
	"./mobile_img/role3/control2/ys2.png": "0KG8",
	"./mobile_img/role3/control2/zl1.png": "6/HU",
	"./mobile_img/role3/control2/zl2.png": "4aXa",
	"./mobile_img/role3/cz/irole.png": "9Kvb",
	"./mobile_img/role3/cz/m_name.png": "+IH0",
	"./mobile_img/role3/cz/m_role.png": "qvjb",
	"./mobile_img/role3/jw/irole.png": "00N5",
	"./mobile_img/role3/jw/m_name.png": "gX+m",
	"./mobile_img/role3/jw/m_role.png": "2JK7",
	"./mobile_img/role3/kc/irole.png": "3viB",
	"./mobile_img/role3/kc/m_name.png": "QgU+",
	"./mobile_img/role3/kc/m_role.png": "5vQZ",
	"./mobile_img/role3/kr/irole.png": "QlpO",
	"./mobile_img/role3/kr/m_name.png": "2vKa",
	"./mobile_img/role3/kr/m_role.png": "AFgK",
	"./mobile_img/role3/lxx/irole.png": "uxLI",
	"./mobile_img/role3/lxx/m_name.png": "5FZk",
	"./mobile_img/role3/lxx/m_role.png": "Tax1",
	"./mobile_img/role3/mx/irole.png": "9ykK",
	"./mobile_img/role3/mx/m_name.png": "pp7i",
	"./mobile_img/role3/mx/m_role.png": "vNKE",
	"./mobile_img/role3/mz/irole.png": "0wYK",
	"./mobile_img/role3/mz/m_name.png": "nuEv",
	"./mobile_img/role3/mz/m_role.png": "JjEL",
	"./mobile_img/role3/oo/irole.png": "uIag",
	"./mobile_img/role3/oo/m_name.png": "wLwt",
	"./mobile_img/role3/oo/m_role.png": "Dx1w",
	"./mobile_img/role3/qa/irole.png": "I73m",
	"./mobile_img/role3/qa/m_name.png": "oSXS",
	"./mobile_img/role3/qa/m_role.png": "DJqn",
	"./mobile_img/role3/swbnzk/irole.png": "VnMs",
	"./mobile_img/role3/swbnzk/m_name.png": "VZj5",
	"./mobile_img/role3/swbnzk/m_role.png": "Xxfx",
	"./mobile_img/role3/sy/irole.png": "lh03",
	"./mobile_img/role3/sy/m_name.png": "GD9n",
	"./mobile_img/role3/sy/m_role.png": "PBO8",
	"./mobile_img/role3/title.png": "EJxl",
	"./mobile_img/role3/tsz/irole.png": "kj7R",
	"./mobile_img/role3/tsz/m_name.png": "Zo4D",
	"./mobile_img/role3/tsz/m_role.png": "qB1p",
	"./mobile_img/role3/tysdags/irole.png": "tjo3",
	"./mobile_img/role3/tysdags/m_name.png": "8n0A",
	"./mobile_img/role3/tysdags/m_role.png": "j5NI",
	"./mobile_img/role3/u/irole.png": "InyB",
	"./mobile_img/role3/u/m_name.png": "Aohi",
	"./mobile_img/role3/u/m_role.png": "vK/d",
	"./mobile_img/role3/wxsjglm/irole.png": "mTaF",
	"./mobile_img/role3/wxsjglm/m_name.png": "kTIe",
	"./mobile_img/role3/wxsjglm/m_role.png": "zy86",
	"./mobile_img/role3/xk/irole.png": "fhGQ",
	"./mobile_img/role3/xk/m_name.png": "xHZp",
	"./mobile_img/role3/xk/m_role.png": "J2rn",
	"./mobile_img/role3/yjyx/irole.png": "UeiY",
	"./mobile_img/role3/yjyx/m_name.png": "3sJc",
	"./mobile_img/role3/yjyx/m_role.png": "Zfn3",
	"./mobile_img/role3/yzzzbq/irole.png": "JLf5",
	"./mobile_img/role3/yzzzbq/m_name.png": "D7Xf",
	"./mobile_img/role3/yzzzbq/m_role.png": "4ESz",
	"./mobile_img/role3/zxrx/irole.png": "N+BC",
	"./mobile_img/role3/zxrx/m_name.png": "xLHq",
	"./mobile_img/role3/zxrx/m_role.png": "rylL",
	"./mobile_img/sprite2310.png": "46Qi",
	"./upload/commonality/20231121/170053375636586479149357.png": "UAg9",
	"./upload/commonality/20251009/0.jpg": "1Szp",
	"./upload/commonality/20251009/1.jpg": "hvkC",
	"./upload/commonality/20251009/2.jpg": "08AQ",
	"./upload/commonality/20251009/3.jpg": "K9fy",
	"./upload/commonality/20251009/4.jpg": "YPPl",
	"./upload/commonality/20251009/5.jpg": "YcSy",
	"./upload/picture/2.4.jpg": "jfyQ",
	"./upload/picture/2.5.jpg": "wmtO",
	"./upload/picture/2.6.jpg": "yIBG",
	"./upload/picture/2.7.jpg": "K4Ki",
	"./upload/video/20251009/11111.png": "rHHL",
	"./upload/video/20251009/22222.png": "4jlg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BoaM";


//////////////////
// WEBPACK FOOTER
// ./static/en ^\.\/.*$
// module id = BoaM
// module chunks = 7